import { useEffect } from 'react';

export default function Recensioni() {
  return (
    <div className="mt-5">
      <div className="elfsight-app-e4d6563f-e640-4648-ad8c-952fa9e87407" data-elfsight-app-lazy></div>
    </div>
  );
}
